<template>
  <div class="expiry">
    <div class="col-12 row">
      <div class="expiryTitle">
        <h2 v-html="introduction.headlineText" class="headline"></h2>
        <div class="subHeaderText">
          <p>
            <strong>This page has moved.</strong> Investor Choice is now available directly on <strong>ProxyVote.com</strong>
          </p>
          <p>
            Submit your voting instructions by signing in with the same email address where you received your original message.
          </p>
          
          <a href="https://ptv.proxyvote.com/pv/ptv/retail">
            <button>
              Continue to ProxyVote.com &nbsp;
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8 0L9.8 1L15.2 6.5H0V7.9H15.2L9.8 13.4L10.8 14.4L18 7.2L10.8 0Z" fill="currentColor"/>
              </svg>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Expiry",
  props: {
    introduction: Object 
  },
  computed: {
     
  },
};
</script>
<style lang="scss">
.row {
  .expiryTitle {
    padding: 50px 40px;
    .subHeaderText {
      font-size: 24px;
      line-height: 150%;
      margin: 30px 0 0 0;
      color: var(--primaryText);

      p {
        font-size: 20px;
        line-height: 150%;        
      }
    }

    .headline {
      font-size: 50px;
      line-height: 120%;
      font-weight: 400;
      color: var(--secondaryText);
      margin: 0;

      p {
        color: inherit;
        font-size: inherit;
        line-height: inherit;
        margin: 0;
      }
    }
  }
}

.expiry {
  font-family: var(--micrositeTypeStyle);
  background-color: white;
  
   button {
    @include primary-btn();
    background-color: var(--headerBar);
    font-size: 16px;
    display: inline-flex;
    align-items: center; 
    margin: 15px 0 0 0;

    &:hover {
      svg {
        fill: var(--button);
      }        
    }
  }
}

.expiry p,
.expiry h2 {
  font-weight: 400;
}

.headerContent {
  h3 {
    margin: 0 0 20px 0;
  }
  .content-holder {
    margin-bottom: 30px;
  }
  .content {
    font-size: 15px;
    line-height: 150%;
    color: var(--primaryText);
  }
}

.expiry .headerContent {
  background-color: var(--backgroundAccent);
  padding: 40px;
}

@include media-breakpoint-down(md) {
  .expiry .expiryTitle,
  .headerContent {
    padding: 30px !important;
  }
}
</style>
